import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { timesheetApi, allocationService, Util } from "../../../services";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Fragment } from "react";
import { toast } from "react-toastify";

const OpenDeallocationDialog = ({ onClose, projectData, allocTypeVisible, resourceAvailablity }) => {
  const [selectedProject, setSelectedProject] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const [allocType, setAllocType] = useState([]);
  const [updatedAllocationType, setUpdatedAllocationType] = useState("");
  const [isCount, setIsCount] = useState(1);
  const [rowClick, setRowClick] = useState(false);
  const [teamsProjectData, setTeamProjectData] = useState(projectData);
  const [resourceAvail, setResourceAvail] = useState(resourceAvailablity);
  let count = 0
  useEffect(() => {
    if (count == 0) {
      getAllocationtypes();
      count++;
    }
  }, []);

  const getAllocationtypes = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocType(resp?.data?.data);
    });
  };

  const getManagerUserInfo = () => {
    timesheetApi.getUsersBySuperior().then((resp) => {
      try {
        setEmployeeList(resp?.data?.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const rowClass = (selectedProject) => {
    return {
     'row-accessories-editAlloc': selectedProject.status === 3
      }
    
  }

  const onCloseMethod = () => {
    onClose();
  };

  const projectBodyTemplate = (rowData) => {
    return rowData?.Project?.title;
  };

  const changeBillable = (e) => {
    projectData.map((item) => {
      if (item.id === e.target.id) {
        item.isBillable = !item.isBillable;
      }
    });
    setIsCount(isCount + 1);
  };

  const fetchBillable = (i) => {
    var isBillable;
    projectData.map((item) => {
      if (item.id === i) {
        isBillable = item.isBillable;
      }
    });

    return isBillable;
  };

  const billableBodyTemplate = (rowData) => {
    return (
      <Checkbox
        id={rowData.id}
        checked={rowData.isBillable}
        onChange={changeBillable}
      />
    );
  };

  const selectProjectList = (e) => {
    setSelectedProject(e.value);
    e.value.length > 0 ? setButtonDisabled(false) : setButtonDisabled(true);
  };

  const reject = () => {
    onCloseMethod();
  };

  const deAllocateProject = () => {
    confirmDialog({
      message: "Do you want to deallocate this record?",
      header: "Deallocation Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const accept = () => {
    let projectId = selectedProject.map((a) => a.id);
    let param = {
      ids: projectId,
    };
    timesheetApi.updateDeallocation(param).then(
      (resp) => {
        if (resp) {
          onClose();
          getManagerUserInfo();
        }
      },
      (error) => { }
    );
  };

  const endDateEditor = (options) => {
    let dateArray = options.rowData.startDate.split("-");
    let dateObj = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
    return (
      <Calendar showIcon placeholder={options.value} dateFormat="dd-mm-yy" value={options.value} minDate={dateObj} onChange={(e) => options.editorCallback(e.value)} />
    );
  };

  const listEditor = (options) => {
    let list = [];
    let field = "title";
    let fieldval = "id";
    switch (options.field) {
      case "allocationType":
        list = allocType;
        fieldval = "id";
        field = "title";
        setUpdatedAllocationType(options.value);
        return (
          <Fragment>
            <Dropdown value={options.value} options={list} optionLabel={field} optionValue={fieldval} onChange={(e) => options.editorCallback(e.value)} placeholder="Select One"
              itemTemplate={(option) => {
                return <span>{option[field]}</span>;
              }}
            />
          </Fragment>
        );
        break;
      case "percentage":
        if (updatedAllocationType === 1) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value="100" maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value))} disabled />
          );
        } else if (updatedAllocationType === 2) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value={options.value} maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value ? e.target.value : 0))} />
          );
        } else if (updatedAllocationType === 3) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value="0" maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value))} disabled />
          );
        } else {
          return options.value ? options.value : 0;
        }
        break;
      default:
        return "";
    }
  };

  const listBodyTemplate = (options, name) => {
    let listName = "";
    switch (name) {
      case "alType":
        var obj = allocType.find((x) => {
          return x.id === options.allocationType;
        });
        listName = obj?.title;
        break;
      case "percentage":
        listName = options?.percentage;
        break;
      default:
        listName = "";
    }
    return listName;
  };

  const editRowComplete = (e) => {
    let prevPercentage;
    let totAvalPercentage;
    let _teamsProjectData = [...teamsProjectData];
    let { newData, index } = e;
    _teamsProjectData[index] = newData;
    const allcPercentage =
      _teamsProjectData[index].allocationType === 1
        ? 100
        : _teamsProjectData[index].allocationType === 2
          ? _teamsProjectData[index].percentage
          : 0;
    prevPercentage = e.data.percentage;
    let allcEndDate;
    if (e.data.endDate === e.newData.endDate) {
      allcEndDate = e.data.endDate;
    } else {
      allcEndDate = Util.dateConverterForAttendance(_teamsProjectData[index].endDate);
    }
    let param = {
      id: _teamsProjectData[index].id,
      allocationType: _teamsProjectData[index].allocationType,
      percentage: allcPercentage,
      endDate: allcEndDate,
      isBillable: fetchBillable(_teamsProjectData[index].id),
    };
    if (allcPercentage <= prevPercentage) {
      try {
        allocationService.updateAllocation(param).then(
          (resp) => {
            if (resp) {
              setTeamProjectData(resp.data.allocations);
              setResourceAvail(resp.data.availability);
              toast.success("Allocation updated successfully!");
            }
          },
          (err) => {
            toast.error("Unable to update allocation");
          }
        );
      } catch (error) {
        toast.error("Unable to update allocation");
      }
    } else {
      totAvalPercentage = prevPercentage + resourceAvail;
      if (allcPercentage > totAvalPercentage) {
        toast.error("Allocation percentage should not greater than 100");
      } else {
        try {
          allocationService.updateAllocation(param).then(
            (resp) => {
              if (resp) {
                setTeamProjectData(resp.data.allocations);
                setResourceAvail(resp.data.availability);
                toast.success("Allocation updated successfully!");
              }
            },
            (err) => {
              toast.error("Unable to update allocation");
            }
          );
        } catch (error) {
          toast.error("Unable to update allocation");
        }
      }
    }
  };


  const deallocationDialog = (
    <>
      <Card>
        {isCount && (
          <div className="col-12 row-accessories-editAlloc">
            <DataTable key={"deallocation"} style={{ width: '1000px' }} responsiveLayout="scroll" paginator
              selection={selectedProject} onSelectionChange={(e) => selectProjectList(e)} paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" value={teamsProjectData} rows={10} rowsPerPageOptions={[10, 20, 50]} dataKey="id"
              rowClassName={rowClass}
              editMode="row" onRowEditComplete={editRowComplete} selectionMode={rowClick ? null : "checkbox"}>
              <Column selectionMode="multiple" headerStyle={{ width: "2rem" }} exportable={false}></Column>
              <Column header="Project" body={projectBodyTemplate} bodyStyle={{ textAlign: 'left' }} headerStyle={{ width: "10rem" }} sortable ></Column>
              {allocTypeVisible && (
                <Column header="Allocation Type" field="allocationType" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "alType")} bodyStyle={{ textAlign: "center" }}></Column>
              )}
              <Column header="Percentage(%)" field="percentage" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "percentage")} bodyStyle={{ textAlign: "center" }}></Column>
              <Column header="Start Date" field="startDate" bodyStyle={{ textAlign: 'center' }}></Column>
              <Column header="End date" field="endDate" style={{ paddingLeft: '55px' }} headerStyle={{ width: "15rem" }} editor={(options) => endDateEditor(options)}></Column>
              <Column header="Billable" body={billableBodyTemplate} bodyStyle={{ textAlign: "center" }}></Column>
              <Column rowEditor headerStyle={{ minWidth: "8rem" }} style={{ paddingLeft: '45px' }}></Column>
            </DataTable>
          </div>
        )}
      </Card>
      <div className="grid text-right popup_btn">
        <div className="col-12">
          <div className="mt-4">
            <Button label="Cancel" className="p-button-rounded p-default" onClick={(e) => onCloseMethod(e)} />
            <Button label="De-allocate" className="p-button-rounded ml-2" onClick={deAllocateProject} disabled={buttonDisabled} />
          </div>
        </div>
      </div>
    </>
  );
  return <React.Fragment>{deallocationDialog}</React.Fragment>;
};
export default OpenDeallocationDialog;
